// Domain 04 — RouteZero Batangas Regional WAN (Batangas City).
//
//                         ISP (unmanaged carrier / Internet) ── WEB 192.0.2.10 (cloud apps)
//            G0/0 203.0.113.0/30 │        │ G0/1 198.51.100.0/30     │ G0/2 198.51.100.4/30
//                                │        │                          │
//   SRV-HQ .10 ─┐                │        │                         CEB  Cebu office (unmanaged)
//   PBX-HQ .20 ─┤ G0/2           │        │ G0/0                     │ G0/1 10.20.10.0/24 ── SRV-CEB .10
//   PC-HQ  .50 ─┴ R1 Manila HQ edge        R2 Batangas Regional WAN Hub ─ G0/1 ─ PC-BTG .10, PH-BTG .20
//   10.10.10.0/24   S0/0/0 ════ primary leased line T1 ════ S0/0/0      10.40.10.0/24
//                   (DCE)        172.16.12.0/30               │ S0/0/1 ═ 172.16.24.0/30 ═ LIPA branch
//                   G0/1 ── backup carrier Ethernet 10 Mbps ── R3 Batangas alternate edge ─ G0/2 R2
//                         172.16.13.0/30                       G0/1 10.40.0.0/30
//
//   VPN: R2 Tunnel0 172.16.99.1/30 ⇄ (IPsec over the Internet) ⇄ CEB Tunnel0 172.16.99.2/30
//
// RouteZero address plan used throughout D04:
//   HQ LAN 10.10.10.0/24 · Batangas LAN 10.40.10.0/24 · Lipa LAN 10.40.20.0/24 · Cebu LAN 10.20.10.0/24

import { pc, server, router, sw, link, network } from '../../engine/net/model.js';
import { createInterface } from '../../engine/ios/switching.js';

const M = { 24: '255.255.255.0', 30: '255.255.255.252', 32: '255.255.255.255' };
const ipm = (s) => { const [ip, p] = s.split('/'); return { ip, mask: M[p] }; };

export const ADDR = {
  R1: { 'GigabitEthernet0/0': '203.0.113.2/30', 'GigabitEthernet0/1': '172.16.13.1/30', 'GigabitEthernet0/2': '10.10.10.1/24', 'Serial0/0/0': '172.16.12.1/30' },
  R2: { 'GigabitEthernet0/0': '198.51.100.2/30', 'GigabitEthernet0/1': '10.40.10.1/24', 'GigabitEthernet0/2': '10.40.0.1/30', 'Serial0/0/0': '172.16.12.2/30', 'Serial0/0/1': '172.16.24.1/30' },
  R3: { 'GigabitEthernet0/0': '172.16.13.2/30', 'GigabitEthernet0/1': '10.40.0.2/30' },
  ISP: { 'GigabitEthernet0/0': '203.0.113.1/30', 'GigabitEthernet0/1': '198.51.100.1/30', 'GigabitEthernet0/2': '198.51.100.5/30', 'GigabitEthernet0/3': '192.0.2.1/24' },
  CEB: { 'GigabitEthernet0/0': '198.51.100.6/30', 'GigabitEthernet0/1': '10.20.10.1/24' },
  LIPA: { 'GigabitEthernet0/1': '10.40.20.1/24', 'Serial0/0/0': '172.16.24.2/30' },
};
export const DESC = {
  R1: { 'GigabitEthernet0/0': 'ISP-INTERNET-MANILA', 'GigabitEthernet0/1': 'BACKUP-CARRIER-ETH-BTG', 'GigabitEthernet0/2': 'HQ-LAN', 'Serial0/0/0': 'PRIMARY-T1-BATANGAS' },
  R2: { 'GigabitEthernet0/0': 'ISP-DIA-BATANGAS', 'GigabitEthernet0/1': 'BTG-LAN', 'GigabitEthernet0/2': 'TO-R3-ALT-EDGE', 'Serial0/0/0': 'PRIMARY-T1-MANILA', 'Serial0/0/1': 'LIPA-BRANCH' },
  R3: { 'GigabitEthernet0/0': 'BACKUP-CARRIER-ETH-MNL', 'GigabitEthernet0/1': 'TO-R2-WAN-HUB' },
  ISP: {}, CEB: {}, LIPA: { 'GigabitEthernet0/1': 'LIPA-LAN', 'Serial0/0/0': 'WAN-BATANGAS' },
};
const PORTS = {
  R1: ['GigabitEthernet0/0', 'GigabitEthernet0/1', 'GigabitEthernet0/2', 'Serial0/0/0', 'Serial0/0/1'],
  R2: ['GigabitEthernet0/0', 'GigabitEthernet0/1', 'GigabitEthernet0/2', 'Serial0/0/0', 'Serial0/0/1'],
  R3: ['GigabitEthernet0/0', 'GigabitEthernet0/1', 'GigabitEthernet0/2'],
  ISP: ['GigabitEthernet0/0', 'GigabitEthernet0/1', 'GigabitEthernet0/2', 'GigabitEthernet0/3'],
  CEB: ['GigabitEthernet0/0', 'GigabitEthernet0/1'],
  LIPA: ['GigabitEthernet0/0', 'GigabitEthernet0/1', 'Serial0/0/0', 'Serial0/0/1'],
};
const SEQ = { R1: 1, R2: 2, R3: 3, ISP: 9, CEB: 6, LIPA: 5 };

/** Give an interface its planned address and bring it up. */
export function address(r, names = Object.keys(ADDR[r.id])) {
  for (const n of names) {
    const i = createInterface(r, n);
    Object.assign(i, { ip: ipm(ADDR[r.id][n]), shutdown: false, description: DESC[r.id]?.[n] || '' });
  }
  return r;
}
export function mkRouter(id, { addressed = true, only } = {}) {
  const r = router(id, { seq: SEQ[id], ports: PORTS[id] });
  if (addressed) address(r, only || Object.keys(ADDR[id]));
  if (id === 'ISP' || id === 'CEB') r.managed = false;
  return r;
}
const host = (id, ip, gw, mac, extra = {}) => pc(id, { ip, mask: '255.255.255.0', gw, mac, ...extra });
const srv = (id, ip, gw, mac, services, extra = {}) => server(id, { ip, mask: '255.255.255.0', gw, mac, services, ...extra });

export const S = (r, net, mask, nh, ad) => { r.routes.push({ net, mask, ...(nh === 'Null0' || /^(Tunnel|Serial|Gigabit)/.test(nh) ? { ifc: nh } : { nh }), ...(ad ? { ad } : {}) }); };
export const T1 = { type: 'V.35 serial (carrier T1)', connector: 'Smart Serial', rateKbps: 1544 };

/**
 * Build the regional WAN. Parts (all optional, default false unless noted):
 *   hq (R1 + HQ LAN, default true) · btg (R2 + Batangas LAN, default true)
 *   primary  R1–R2 T1        backup  R3 alternate edge + carrier Ethernet
 *   isp      ISP + WEB (R1 and R2 uplinks)   ceb  Cebu office behind the ISP
 *   lipa     Lipa branch on R2 S0/0/1        addressed  routers carry the address plan (default true)
 */
export function wan({ hq = true, btg = true, primary = false, backup = false, isp = false, ceb = false, lipa = false, addressed = true } = {}) {
  const devs = []; const links = [];
  let R1, R2, R3, ISP;
  if (hq) {
    R1 = mkRouter('R1', { addressed });
    devs.push(R1,
      srv('SRV-HQ', '10.10.10.10', '10.10.10.1', '00155d7a1010', [{ proto: 'tcp', port: 443, name: 'https' }, { proto: 'tcp', port: 445, name: 'smb' }], { http: { title: 'RouteZero ERP', body: 'erp.routezero.example' } }),
      srv('PBX-HQ', '10.10.10.20', '10.10.10.1', '00155d7a1020', [{ proto: 'udp', port: 5060, name: 'sip' }, { proto: 'udp', port: 16384, name: 'rtp' }]),
      host('PC-HQ', '10.10.10.50', '10.10.10.1', '0050797b1050'));
    devs.push(sw('SW-HQ', { seq: 7, fastPorts: 8 }));
    links.push(link('SRV-HQ', 'FastEthernet0', 'SW-HQ', 'FastEthernet0/1'), link('PBX-HQ', 'FastEthernet0', 'SW-HQ', 'FastEthernet0/2'), link('PC-HQ', 'FastEthernet0', 'SW-HQ', 'FastEthernet0/3'),
      link('SW-HQ', 'GigabitEthernet0/1', 'R1', 'GigabitEthernet0/2'));
  }
  if (btg) {
    R2 = mkRouter('R2', { addressed });
    devs.push(R2,
      host('PC-BTG', '10.40.10.10', '10.40.10.1', '0050797b4010'),
      host('PH-BTG', '10.40.10.20', '10.40.10.1', '0050797b4020', { hostname: 'PH-BTG' }));
    devs.push(sw('SW-BTG', { seq: 8, fastPorts: 8 }));
    links.push(link('PC-BTG', 'FastEthernet0', 'SW-BTG', 'FastEthernet0/1'), link('PH-BTG', 'FastEthernet0', 'SW-BTG', 'FastEthernet0/2'), link('SW-BTG', 'GigabitEthernet0/1', 'R2', 'GigabitEthernet0/1'));
  }
  if (!primary) {
    for (const r of [R1, R2].filter(Boolean)) { if (r.interfaces['Serial0/0/0']) { r.interfaces['Serial0/0/0'].ip = null; r.interfaces['Serial0/0/0'].shutdown = true; r.interfaces['Serial0/0/0'].description = ''; } }
  } else if (R1 && R2) links.push(link('R1', 'Serial0/0/0', 'R2', 'Serial0/0/0', { ...T1, dce: 'R1' }));
  if (backup) {
    R3 = mkRouter('R3', { addressed });
    devs.push(R3);
    links.push(link('R1', 'GigabitEthernet0/1', 'R3', 'GigabitEthernet0/0', { type: 'Cat6 UTP (carrier Ethernet handoff)', rateKbps: 10000 }), link('R3', 'GigabitEthernet0/1', 'R2', 'GigabitEthernet0/2', { type: 'OM4 fiber', connector: 'LC' }));
  } else {
    for (const [r, n] of [[R1, 'GigabitEthernet0/1'], [R2, 'GigabitEthernet0/2']]) if (r?.interfaces[n]) Object.assign(r.interfaces[n], { ip: null, shutdown: true, description: '' });
  }
  if (isp) {
    ISP = mkRouter('ISP');
    devs.push(ISP, srv('WEB', '192.0.2.10', '192.0.2.1', '00155d7aff10', [{ proto: 'tcp', port: 443, name: 'https' }, { proto: 'tcp', port: 80, name: 'http' }], { http: { title: 'Cloud apps', body: 'apps.cloud.example' } }));
    links.push(link('WEB', 'FastEthernet0', 'ISP', 'GigabitEthernet0/3'));
    if (R1) links.push(link('R1', 'GigabitEthernet0/0', 'ISP', 'GigabitEthernet0/0', { type: 'Cat6 UTP (ISP handoff)' }));
    if (R2) links.push(link('R2', 'GigabitEthernet0/0', 'ISP', 'GigabitEthernet0/1', { type: 'Cat6 UTP (ISP handoff)' }));
  } else {
    for (const r of [R1, R2].filter(Boolean)) Object.assign(r.interfaces['GigabitEthernet0/0'], { ip: null, shutdown: true, description: '' });
  }
  if (ceb && isp) {
    const CEB = mkRouter('CEB');
    devs.push(CEB, srv('SRV-CEB', '10.20.10.10', '10.20.10.1', '00155d7a2010', [{ proto: 'tcp', port: 445, name: 'smb' }, { proto: 'tcp', port: 443, name: 'https' }]));
    links.push(link('CEB', 'GigabitEthernet0/0', 'ISP', 'GigabitEthernet0/2', { type: 'Cat6 UTP (ISP handoff)' }), link('SRV-CEB', 'FastEthernet0', 'CEB', 'GigabitEthernet0/1'));
    S(CEB, '0.0.0.0', '0.0.0.0', '198.51.100.5');
  }
  if (lipa && R2) {
    const LIPA = mkRouter('LIPA', { addressed });
    devs.push(LIPA, host('PC-LIPA', '10.40.20.10', '10.40.20.1', '0050797b4210'));
    links.push(link('R2', 'Serial0/0/1', 'LIPA', 'Serial0/0/0', { ...T1, type: 'V.35 serial (carrier E1/T1 tail)', dce: 'R2' }), link('PC-LIPA', 'FastEthernet0', 'LIPA', 'GigabitEthernet0/1'));
  } else if (R2) Object.assign(R2.interfaces['Serial0/0/1'], { ip: null, shutdown: true, description: '' });
  return network(devs, links);
}

// ------------------------------------------------------------ configuration presets (lab baselines)
/** Static WAN design: primary over the T1, floating backup (AD 250) through R3. */
export function wanRoutes(n, { backupRoutes = true } = {}) {
  const { R1, R2, R3 } = n.devices;
  if (R1) { S(R1, '10.40.10.0', '255.255.255.0', '172.16.12.2'); if (backupRoutes && R3) S(R1, '10.40.10.0', '255.255.255.0', '172.16.13.2', 250); }
  if (R2) { S(R2, '10.10.10.0', '255.255.255.0', '172.16.12.1'); if (backupRoutes && R3) S(R2, '10.10.10.0', '255.255.255.0', '10.40.0.2', 250); }
  if (R3) { S(R3, '10.10.10.0', '255.255.255.0', '172.16.13.1'); S(R3, '10.40.10.0', '255.255.255.0', '10.40.0.1'); }
  return n;
}
/** Internet edge: defaults to the ISP and PAT on both edge routers. */
export function internetEdge(n, { r1 = true, r2 = true } = {}) {
  const { R1, R2 } = n.devices;
  const pat = (r, inside, acl) => {
    for (const i of inside) if (r.interfaces[i]) r.interfaces[i].nat = 'inside';
    r.interfaces['GigabitEthernet0/0'].nat = 'outside';
    r.acls[1] = acl;
    r.nat.rules.push({ acl: '1', ifc: 'GigabitEthernet0/0', overload: true });
  };
  if (r1 && R1) { S(R1, '0.0.0.0', '0.0.0.0', '203.0.113.1'); pat(R1, ['GigabitEthernet0/2', 'Serial0/0/0', 'GigabitEthernet0/1'], [{ action: 'permit', base: '10.0.0.0', wild: '0.255.255.255', text: '10.0.0.0 0.255.255.255' }]); }
  if (r2 && R2) { S(R2, '0.0.0.0', '0.0.0.0', '198.51.100.1'); pat(R2, ['GigabitEthernet0/1'], [{ action: 'permit', base: '10.40.10.0', wild: '0.0.0.255', text: '10.40.10.0 0.0.0.255' }]); }
  return n;
}

// ------------------------------------------------------------ VPN presets
export const VPN = { key: 'RzBtgVpn2026', policy: { encr: 'aes 256', hash: 'sha256', auth: 'pre-share', group: 14, lifetime: 86400 }, ts: ['esp-aes 256', 'esp-sha256-hmac'] };
/** IPsec VTI between two routers (each side: { id, src interface, peer public IP, tunnel IP, remote LAN }). */
export function vtiSide(r, { srcIfc, peer, tunnelIp, remote, profile = 'VPN-PROFILE', key = VPN.key, route = true }) {
  r.crypto = {
    isakmp: { policies: { 10: { ...VPN.policy } }, keys: [{ key, address: peer }] },
    transformSets: { 'TS-AES256': { transforms: [...VPN.ts], mode: 'tunnel' } },
    profiles: { [profile]: { transformSet: 'TS-AES256' } },
  };
  const t = createInterface(r, 'Tunnel0');
  Object.assign(t, { ip: ipm(tunnelIp), shutdown: false, description: `VPN-TO-${peer}`, tunnel: { source: srcIfc, destination: peer, mode: 'ipsec', protection: profile } });
  if (route) S(r, remote[0], remote[1], 'Tunnel0');
  return r;
}
/** Batangas ⇄ Cebu VPN (final challenge and operations lab). */
export function cebuVpn(n) {
  vtiSide(n.devices.R2, { srcIfc: 'GigabitEthernet0/0', peer: '198.51.100.6', tunnelIp: '172.16.99.1/30', remote: ['10.20.10.0', '255.255.255.0'], profile: 'VPN-CEB' });
  vtiSide(n.devices.CEB, { srcIfc: 'GigabitEthernet0/0', peer: '198.51.100.2', tunnelIp: '172.16.99.2/30', remote: ['10.40.10.0', '255.255.255.0'], profile: 'VPN-BTG' });
  return n;
}
/** Batangas ⇄ Manila VPN over the Internet (Missions 11–12). */
export function manilaVpn(n, { r2 = true } = {}) {
  vtiSide(n.devices.R1, { srcIfc: 'GigabitEthernet0/0', peer: '198.51.100.2', tunnelIp: '172.16.98.1/30', remote: ['10.40.10.0', '255.255.255.0'], profile: 'VPN-BTG' });
  if (r2) vtiSide(n.devices.R2, { srcIfc: 'GigabitEthernet0/0', peer: '203.0.113.2', tunnelIp: '172.16.98.2/30', remote: ['10.10.10.0', '255.255.255.0'], profile: 'VPN-MNL' });
  return n;
}

// ------------------------------------------------------------ QoS presets
/** User traffic during the Batangas peak hour (rate model, see engine/net/qos.js). */
export function peakTraffic(n, { business = true } = {}) {
  n.traffic = [
    { id: 'voice', name: 'Voice calls PH-BTG → PBX-HQ (2 × G.711)', src: 'PH-BTG', dst: '10.10.10.20', proto: 'udp', port: 16384, app: 'rtp', kbps: 174, dscp: 0, type: 'voice' },
    ...(business ? [{ id: 'erp', name: 'ERP (HTTPS) PC-BTG → SRV-HQ', src: 'PC-BTG', dst: '10.10.10.10', proto: 'tcp', port: 443, app: 'https', kbps: 320, dscp: 0, type: 'data' }] : []),
    { id: 'backup', name: 'File backup (SMB) PC-BTG → SRV-HQ', src: 'PC-BTG', dst: '10.10.10.10', proto: 'tcp', port: 445, app: 'smb', kbps: 1480, dscp: 0, type: 'bulk' },
  ];
  return n;
}
/** The QoS design: mark voice at the LAN edge, LLQ on the T1. */
export function qosDesign(n, { mark = true, attach = true, business = true } = {}) {
  const r = n.devices.R2;
  r.qos = {
    classMaps: {
      'VOICE-IN': { matchAny: false, matches: [{ type: 'protocol', value: 'rtp' }] },
      VOICE: { matchAny: false, matches: [{ type: 'dscp', values: ['ef'] }] },
      ...(business ? { 'BUSINESS-IN': { matchAny: false, matches: [{ type: 'protocol', value: 'https' }] }, BUSINESS: { matchAny: false, matches: [{ type: 'dscp', values: ['af31'] }] } } : {}),
    },
    policyMaps: {
      'MARK-IN': { classes: [{ name: 'VOICE-IN', set: { dscp: 'ef' } }, ...(business ? [{ name: 'BUSINESS-IN', set: { dscp: 'af31' } }] : []), { name: 'class-default' }] },
      'WAN-EDGE': { classes: [{ name: 'VOICE', priority: { kbps: 256 } }, ...(business ? [{ name: 'BUSINESS', bandwidth: { kbps: 400 } }] : []), { name: 'class-default', fairQueue: true }] },
    },
  };
  if (mark) r.interfaces['GigabitEthernet0/1'].servicePolicy = { input: 'MARK-IN' };
  if (attach) r.interfaces['Serial0/0/0'].servicePolicy = { output: 'WAN-EDGE' };
  return n;
}

/** The complete as-built regional WAN (Missions 13–14). */
export function regionalWan() {
  const n = wan({ primary: true, backup: true, isp: true, ceb: true });
  wanRoutes(n);
  internetEdge(n);
  S(n.devices.R3, '0.0.0.0', '0.0.0.0', '172.16.13.1');
  cebuVpn(n);
  peakTraffic(n);
  qosDesign(n);
  return n;
}

// ------------------------------------------------------------ diagram layouts
const NODE = {
  ISP: { x: 560, y: 62, type: 'cloud', sub: 'Carrier / Internet · unmanaged' },
  WEB: { x: 900, y: 62, type: 'server', sub: 'Cloud apps 192.0.2.10' },
  R1: { x: 190, y: 230, type: 'router', sub: 'Manila HQ WAN edge' },
  'SW-HQ': { x: 130, y: 370, type: 'switch', sub: 'HQ access' },
  'SRV-HQ': { x: 55, y: 500, type: 'server', sub: 'ERP 10.10.10.10' },
  'PBX-HQ': { x: 160, y: 520, type: 'server', sub: 'PBX 10.10.10.20' },
  'PC-HQ': { x: 270, y: 510, type: 'pc', sub: '10.10.10.50' },
  R2: { x: 640, y: 350, type: 'router', sub: 'Batangas Regional WAN Hub' },
  R3: { x: 510, y: 510, type: 'router', sub: 'Batangas alternate edge' },
  'SW-BTG': { x: 770, y: 460, type: 'switch', sub: 'Batangas access' },
  'PC-BTG': { x: 700, y: 590, type: 'pc', sub: '10.40.10.10' },
  'PH-BTG': { x: 840, y: 590, type: 'pc', sub: 'IP phone 10.40.10.20' },
  CEB: { x: 990, y: 230, type: 'router', sub: 'Cebu office · unmanaged' },
  'SRV-CEB': { x: 990, y: 380, type: 'server', sub: '10.20.10.10' },
  LIPA: { x: 450, y: 560, type: 'router', sub: 'Lipa branch' },
  'PC-LIPA': { x: 260, y: 600, type: 'pc', sub: '10.40.20.10' },
};
const LABELS = {
  'R1:GigabitEthernet0/0': '.2', 'ISP:GigabitEthernet0/0': '.1', 'R2:GigabitEthernet0/0': '.2', 'ISP:GigabitEthernet0/1': '.1', 'ISP:GigabitEthernet0/2': '.5', 'CEB:GigabitEthernet0/0': '.6',
  'R1:Serial0/0/0': '.1 DCE', 'R2:Serial0/0/0': '.2', 'R1:GigabitEthernet0/1': '.1', 'R3:GigabitEthernet0/0': '.2', 'R3:GigabitEthernet0/1': '.2', 'R2:GigabitEthernet0/2': '.1',
  'R1:GigabitEthernet0/2': '10.10.10.1', 'R2:GigabitEthernet0/1': '10.40.10.1', 'CEB:GigabitEthernet0/1': '10.20.10.1', 'R2:Serial0/0/1': '.1 DCE', 'LIPA:Serial0/0/0': '.2', 'LIPA:GigabitEthernet0/1': '10.40.20.1',
};
export const LINK = {
  primary: 'R1:Serial0/0/0--R2:Serial0/0/0', backup: 'R1:GigabitEthernet0/1--R3:GigabitEthernet0/0', alt: 'R3:GigabitEthernet0/1--R2:GigabitEthernet0/2',
  hqIsp: 'R1:GigabitEthernet0/0--ISP:GigabitEthernet0/0', btgIsp: 'R2:GigabitEthernet0/0--ISP:GigabitEthernet0/1', cebIsp: 'CEB:GigabitEthernet0/0--ISP:GigabitEthernet0/2',
  lipa: 'R2:Serial0/0/1--LIPA:Serial0/0/0',
};
/**
 * Diagram for any wan() variant: nodes not in the network are skipped by the
 * renderer. `notes` adds protocol text per link key; `vpn` draws the tunnel(s).
 */
export function wanLayout(n, { title, notes = {}, vpn = [], qos = null, extraZones = [] } = {}) {
  const nodes = Object.fromEntries(Object.entries(NODE).filter(([id]) => n.devices[id]));
  const has = (k) => n.links.some((l) => l.id === LINK[k]);
  const ln = {};
  const add = (k, txt) => { if (has(k)) ln[LINK[k]] = notes[k] ? `${txt} · ${notes[k]}` : txt; };
  add('primary', 'PRIMARY T1 1.544M · 172.16.12.0/30');
  add('backup', 'BACKUP 10M · 172.16.13.0/30');
  add('alt', '10.40.0.0/30');
  add('hqIsp', '203.0.113.0/30');
  add('btgIsp', '198.51.100.0/30');
  add('cebIsp', '198.51.100.4/30');
  add('lipa', 'T1 tail · 172.16.24.0/30');
  const zones = [];
  if (n.devices.R1) zones.push({ x: 20, y: 165, w: 350, h: 405, label: 'MANILA HQ · 10.10.10.0/24' });
  if (n.devices.R2) zones.push({ x: n.devices.LIPA ? 200 : 450, y: 300, w: n.devices.LIPA ? 690 : 440, h: 350, label: 'BATANGAS · 10.40.10.0/24' });
  if (n.devices.ISP) zones.push({ x: 380, y: 12, w: 640, h: 102, label: 'CARRIER / INTERNET', cloud: true });
  if (n.devices.CEB) zones.push({ x: 900, y: 160, w: 180, h: 280, label: 'CEBU · 10.20.10.0/24' });
  const overlays = vpn.map((v) => ({ ...v, kind: 'vpn' }));
  if (qos) overlays.push({ kind: 'qos', ...qos });
  return { width: 1100, height: 670, title: title || 'RouteZero regional WAN — Batangas', nodes, zones: [...zones, ...extraZones], linkLabels: LABELS, linkNotes: ln, overlays };
}
